import {
  ROOT,
  GET_ALL_PROMOTION,
  GET_DETAIL_PROMOTION,
  DELETE_PROMOTION,
  CREATE_PROMOTION,
  UPDATE_PROMOTION,
  DUPLICATE_PROMOTION,
  CHANGE_STATUS_PROMOTION,
  SORT_INDEX_PROMOTION,
  VALIDATE_PROMOTION_CODE
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function get(body) {
  return fetch(ROOT + GET_ALL_PROMOTION, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function detail(id) {
  return fetch(ROOT + GET_DETAIL_PROMOTION + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function create(data) {
  return fetch(ROOT + CREATE_PROMOTION, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function update(data) {
  return fetch(ROOT + UPDATE_PROMOTION, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function duplicate(data) {
  return fetch(ROOT + DUPLICATE_PROMOTION, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function updateStatus(data) {
  return fetch(ROOT + CHANGE_STATUS_PROMOTION, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function sortIndex(data) {
  return fetch(ROOT + SORT_INDEX_PROMOTION, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function validatePromotionCode(data) {
  return fetch(ROOT + VALIDATE_PROMOTION_CODE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function remove(id) {
  return fetch(ROOT + DELETE_PROMOTION + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion
export const promotion = {
  get,
  detail,
  create,
  update,
  duplicate,
  remove,
  updateStatus,
  sortIndex,
  validatePromotionCode
};
